export const addToGoogleDataLayer = (virtualPageURL, virtualPageTitle, virtualLanguage) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'Virtual Page View',
      virtualPageURL: virtualPageURL,
      virtualPageTitle: virtualPageTitle,
      virtualLanguage: virtualLanguage,
    })
  }
}
